export default __webpack_public_path__ + "static/media/weight.ee4fc16d.svg";